import { render, staticRenderFns } from "./BotonFlotanteTienda.vue?vue&type=template&id=5b723f8e"
import script from "./BotonFlotanteTienda.vue?vue&type=script&lang=js"
export * from "./BotonFlotanteTienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports